import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import SkeletonExample from '../examples/Skeleton';
const SkeletonExampleSource = require('!!raw-loader!../examples/Skeleton');
const SkeletonPage = () => (<div>
        <Helmet title="Skeleton"/>
        <h3>Skeleton</h3>
        <div className="docs-example">
            <SkeletonExample />
        </div>
        <pre>
            <PrismCode className="language-jsx">{SkeletonExampleSource}</PrismCode>
        </pre>
        <div>
            <h4>Properties</h4>
            <pre>
                <PrismCode className="language-jsx">
                    {`
type SkeletonProps = {
    lines: number;
    type: 'hero' | 'title' | 'text';
    standalone: boolean;
    width: string | number | null;
    theme : 'light' | 'dark';
};
`}
                </PrismCode>
            </pre>
        </div>
    </div>);
export default SkeletonPage;
